
    import { Vue,Component } from 'vue-property-decorator'
    import { State, Action, namespace, Getter} from 'vuex-class'
    import PagedTable from '../../components/common/pagedTable.vue'
    import excom from '../../components/excom.vue'
    import exicon from '../../assets/expressicon'
    const partner = namespace('partner')
    @Component({
        components: {
            PagedTable,
            excom
        }
    })
    export default class Home extends Vue{
        exicon:any = exicon
        partnerInfo:Boolean = false
        rechargeDialog:Boolean = false
        cournid:string = '' //点击充值的id
	    @Getter('type') storesType:any
        search:any = {
            name: '',
            pageSize: 20,
            phone: '',
            excom: '',
            page: 1
        }
        ruleForm:any = {
            amount:'',
            present:'',
            desc:''
        }
        @partner.State('pager') pager:any //表格的页码
        @partner.State('list') pagerList:any //快递员列表
        @partner.State("partnerDetail") partnerDetail:any // 快递员详细信息
        get tablecolumn(){
            return [
                {
                    prop: 'name',
                    name: 'name',
                    type: 'slot',
                    label: '快递员姓名',

                },
                {
                    prop: 'phone',
                    type: 'text',
                    label: '电话',

                },
                {
                    prop: 'price',
                    type: 'text',
                    label: '单价',

                },
                {
                    prop: 'money',
                    type: 'text',
                    label: '余额',
                    color: '#409eff'
                },
                {
                    prop: 'excom',
                    name: 'excom',
                    type: 'slot',
                    label: '快递公司',

                },
                {
                    prop: 'ctime',
                    type: 'text',
                    label: '创建时间',

                },
                {
                    prop: 'status',
                    name: 'status',
                    type: 'slot',
                    label: '状态',

                },
                {
                    prop: 'sort',
                    name: 'sort',
                    type: 'slot',
                    label: '排序',

                },
                {
                    prop: 'desc',
                    type: 'text',
                    label: '备注',

                },
                {
                    prop: 'name',
                    name:'operation',
                    type: 'slot',
                    label: '操作',

                }
            ]
        }
        @partner.Action('getPartnerList') getPartnerList:any
        @partner.Action("getPartnerDetail") getPartnerDetail:any
        @partner.Action("partnerRecharge") partnerRecharge:any
        @partner.Action("partnerSort") partnerSort:any
        @partner.Action("changePartnerStatus") changePartnerStatus:any
        @partner.Action("deletePartner") deletePartner:any
        @partner.Action("unbindPartner") unbindPartner:any

        mounted(){
            this.getList()
            console.log(this.storesType == 1);
            
        }
        getList(){
            this.getPartnerList(this.search)
        }
        lookInfo(id:string){
            this.partnerInfo = true;
            this.getPartnerDetail(id)
        }
        // 添加快递员
        addPartner(){
            this.$router.push('/partner/add')
        }
        // 充值
        async submitrecharge(){
            await this.partnerRecharge({
                id: this.cournid,
                data: this.ruleForm
            })
            this.$message({  message: '充值成功',type: 'success' });
            this.rechargeDialog = false
            this.getList()
        }
        // 点击充值的时候显示弹窗
        handleClick(id:any){
            this.cournid = id
            this.rechargeDialog = true
        }
        // 翻页
        pagechange(e){
            this.search.page = e[0].val
            this.getList()
        }
        async dropmenu(command:any){
            const {val,com} = command
             console.log(val)
            if (com == 'edit') {
                return this.$router.push(`/partner/edit?id=${val._id}`)
            }
            if (com == 'stop' || com == 'start') {
               this.partnerStatus(val._id)
            }
            if (com == 'delete') {
                this.deleteRow(val._id)
            }
        }
        change(e:any){
            this.search.excom = e
        }
        // 排序
        async sort(id:any,num:any,status:any){
            let number = 0;
            if(status == 'sub'){
                if(num-1 < 0){
                    number = 0
                    return
                }else{
                    number = num-1
                }
            }else{
                number = num+1
            }
            const res = await this.partnerSort({
                id: id,
                data: {
                    sort: number
                }
            })
            if(res){
                this.getList()
            }
        }
        // 改变快递员状态停用或启用
        async partnerStatus (id:string){
            const res = await this.changePartnerStatus(id)
            if(res){
                this.$message({  message: '改变成功',type: 'success' });
                this.getList()
            }
        }
        // 删除快递员
        async deleteRow(id:string){
            this.$confirm('此操作将永久删除该快递员, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const res = await this.deletePartner(id)
                if(res){
                    this.$message({  message: '删除成功',type: 'success' });
                    this.getList()
                }
            }).catch(() => {

            });
            
        }
        async unbindPartenrAction(id){
            this.$confirm('此操作将解除绑定此快递员, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const res = await this.unbindPartner(id)
                if(res){
                    this.$message({  message: '解绑成功',type: 'success' });
                }
            }).catch(() => {

            });
        }
    }
